import axios from 'axios';

import { CATEGORY_HUB_URL_INVENTORY_V1 } from '../constants';

import reject from '../reject';

export function getCategoriesWithUncategorized(params) {
  return axios
    .get(CATEGORY_HUB_URL_INVENTORY_V1, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function createCategory(data, params?) {
  return axios
    .post(CATEGORY_HUB_URL_INVENTORY_V1, data, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function getCategoryDetail(id, params?) {
  return axios
    .get(`${CATEGORY_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function updateCategory(id, data, params?) {
  return axios
    .put(`${CATEGORY_HUB_URL_INVENTORY_V1}/${id}`, data, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function deleteCategory(id, params?) {
  return axios
    .delete(`${CATEGORY_HUB_URL_INVENTORY_V1}/${id}`, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function assignCategoryToItem(id, data) {
  return axios
    .post(`${CATEGORY_HUB_URL_INVENTORY_V1}/${id}/apply`, data, {
      withCredentials: true,
    })
    .catch(reject);
}
